import { FC, useEffect, useState } from "react";
import styles from "./CustomSwitch.module.css";
import { Lock, LockOpen } from "lucide-react";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";
import { Ban, Waves } from "lucide-react";

type Props = {
  value: boolean;
  action: (val: boolean) => void;
  disabled: boolean;
  type: "waves" | "lock";
};

export const CustomSwitch: FC<Props> = ({ value, action, disabled, type }) => {
  const [active, setActive] = useState(value);
  const { colors } = useAppColors();

  useEffect(() => {
    setActive(value);
  }, [value]);

  const handleClick = () => {
    if (disabled) return;
    const newValue = !active;
    setActive(newValue);
    action(newValue);
  };

  return (
    <div className={styles.container} onClick={handleClick}>
      <div
        className={styles.switch}
        style={{
          left: active ? "3rem" : "0",
          backgroundColor: active
            ? type === "lock"
              ? colors.red
              : colors.success
            : colors.brand,
          borderColor: colors.primary,
        }}
      >
        {active ? (
          type === "lock" ? (
            <Lock color="#F1F1F3" size={15} />
          ) : (
            <Waves color="#F1F1F3" size={15} />
          )
        ) : type === "lock" ? (
          <LockOpen color="#F1F1F3" size={15} />
        ) : (
          <Ban color="#F1F1F3" size={15} />
        )}
      </div>
    </div>
  );
};
